var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "action-palette",
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "justify-content": "end",
          },
        },
        [
          _vm.bar !== 0
            ? _c("a-icon", {
                staticStyle: { "font-size": "23px" },
                attrs: { type: "close" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close-menu", 0)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.ActionPalette, function (ap, i) {
        return ap.enabled
          ? _c(
              "section",
              { key: i },
              [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    on: {
                      click: function ($event) {
                        return _vm.toggleSection(i)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "chatbotv2." +
                              (ap.group.split(" ").length > 1
                                ? ap.group.split(" ").join("_")
                                : ap.group)
                          )
                        ) +
                        "\n            "
                    ),
                    _vm.sectionStatus[i]
                      ? _c("a-icon", {
                          staticClass: "carrot-icon",
                          attrs: { type: "up" },
                        })
                      : _c("a-icon", {
                          staticClass: "carrot-icon",
                          attrs: { type: "down" },
                        }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slow-accordion" } }, [
                  _vm.sectionStatus[i]
                    ? _c(
                        "div",
                        { staticClass: "items" },
                        _vm._l(ap.items, function (item) {
                          return !item.disabled
                            ? _c(
                                "button",
                                {
                                  key: item.id,
                                  staticClass: "item chatbot-btn",
                                  attrs: { draggable: true },
                                  on: {
                                    dragstart: function (ev) {
                                      return _vm.dragStart(ev, item.id)
                                    },
                                    drag: function (ev) {
                                      return _vm.dragStart(ev, item.id)
                                    },
                                    dragend: function ($event) {
                                      return _vm.dragEnd()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("BlockIconPreview", {
                                        staticClass: "img",
                                        staticStyle: { "font-size": "24px" },
                                        attrs: { "block-type": item.id },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center align-content-center justify-content-start",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "blockTypeText" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .$t("chatbotv2." + item.id)
                                                .toLocaleLowerCase(
                                                  _vm.$i18n.locale
                                                )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }